import React, { useState, useEffect } from "react";
import Logo from "../../assets/images/GPM-ICON.png";
import Coin from "../../assets/images/coin-icon-svg.svg";
import Diamond from "../../assets/images/diamond-icon.png";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../Utilities/routesFb";
import { func } from "../../Utilities/logFunc";
import { getAccountProfile, getLanguage } from "../../Utilities/controller";
import JoinViaInviteCodeModal from "./JoinViaCode/JoinViaInviteCodeModal";
import ApplyPromoCodeModel from "./ApplyPromoCode/ApplyPromoCodeModel";
import SuccessPromoCodeModal from "./ApplyPromoCode/SuccessPromoCodeModal";
import TournamentConfirmationModal from "./Tournament/TournamentConfirmationModal";
import TournamentModal from "./Tournament/TournamentModal";
import WinningBreakUp from "./Tournament/WinningBreakUp";
import JoinModal from "./Tournament/JoinModal";
import ReferAFriend from "./ReferAFriend/ReferAFriend";
import Logout from "../Auth/Logout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GamerjiPoints from "./GamerjiPoints/GamerjiPoints";
import Profile from "../../assets/images/profile-icon-svg.svg";
import JVC from "../../assets/images/link-icon-svg.svg";
import PromoCode from "../../assets/images/applyPromocode-icon-svg.svg";
import Friend from "../../assets/images/referFriend-icon-svg.svg";
import Points from "../../assets/images/list-icon-svg.svg";
import Legality from "../../assets/images/legality-icon-svg.svg";
import Favorite from "../../assets/images/favouriteGame-icon-svg.svg";
import LogoutIcon from "../../assets/images/logout-icon-svg.svg";
import { url as URL } from "../../Utilities/url";

import FavoriteGamesModal from "./FavoriteGames/FavoriteGamesModal";
import DailyLoginRewardModal from "./DailyLoginReward/DailyLoginRewardModal";
import EditProfile from "../Profile/EditProfile";
import MyProfile from "../Profile/MyProfile";
import { useProfileDataContext } from "./ProfileContext";
import { logout } from "../../Utilities/logout";
import i18next from "i18next";
import { t } from "i18next";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { eventTracking } from "../../firebaseAnalytics";
import { events } from "../../Utilities/appEvents";
import { useTheme } from "../../ThemeContext";

const Navbar = ({ activeNav, isActiveMenu, seActiveMenu }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navsv = [
    "/home",
    "/home/world-of-esports",
    "/home/coin-store",
    "/home/reward-store",
    "/home/leader-board",
    "/home/customer-care",
    "/home/get-premium",
  ];
  const navName = [
    "sidebar.all_games",
    "sidebar.world_of_esports",
    "sidebar.coin_store",
    "sidebar.reward_store",
    "sidebar.leaderboard",
    "sidebar.customer_care",
    "sidebar.explore_premium",
  ];

  const [url, setUrl] = useState(window.location.href.split("/").length - 3);
  // const [profileData, setProfileData] = useState(null);
  const [showJVC, setShowJVC] = useState(false);
  const [showAPC, setShowAPC] = useState(false);
  const [showSPC, setShowSPC] = useState(false);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showWinningModal, setShowWinningModal] = useState(false);
  const [showTournamentModal, setShowTournamentModal] = useState(false);
  const [showTournamentConfirmationModal, setShowTournamentConfirmationModal] =
    useState(false);
  const [showReferFriend, setShowReferFriend] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [showGamerjiPointsModal, setShowGamerjiPointsMOdal] = useState(false);
  const [showFavoriteGame, setShowFavoriteGame] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [showDLR, setShowDLR] = useState(false);
  const [active, setActive] = useState(null);
  const { profileData, updateProfileData } = useProfileDataContext();
  const {themeName, changeTheme} = useTheme()
  // console.log(themeName, changeTheme)
  // var user_data = JSON.parse(localStorage.getItem("profile"))?.item;

  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("GJLang") || Cookies.get("GJLang") || "English"
  );
  const [loader, setLoader] = useState(false);

  const [coinId, setCoinId] = useState(
    profileData?.item?.wallet?.findIndex(
      (obj) => obj.currencyData?.code == "DC"
    )
  );
  const [diamondId, setDiamondId] = useState(
    profileData?.item?.wallet?.findIndex(
      (obj) => obj.currencyData?.code == "D11"
    )
  );

  const currentLang =
    localStorage.getItem("GJLangCode") || Cookies.get("GJLangCode") || "en";

  const fetchLanguage = async () => {
    const body = {
      companyId: process.env.REACT_APP_COMPANY_ID,
    };
    try {
      const res = await getLanguage(body);
      // console.log("fetchLanguage",res?.data?.data)
      setLanguages(res?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchLanguage();
    const linkTag = document.getElementById("bootstrap_css");
    document.documentElement.setAttribute("lang", currentLang.toLowerCase());
    document.documentElement.dir =
      currentLang.toLowerCase() == "ar" ? "rtl" : "ltr";
    if (currentLang.toLowerCase() == "ar") {
      linkTag?.setAttribute(
        "href",
        `${process.env.REACT_APP_CLIENT_BASE_URL}assets/css/bootstrap.rtl.min.css`
      );
    }

    // document.title = t("title");
    document.title = "Go Play Gaming Portal";
  }, [currentLang]);

  const handleApplyPromoCode = () => {
    eventTracking(events.APPLY_PROMO_CODE);
    setShowAPC(true);
  };

  const getTotalCoin = () => {
    let index = profileData?.item?.wallet?.findIndex(
      (obj) => obj.currencyData?.code == "gp_coin"
    );

    if (index > -1) {
      return profileData?.item?.wallet[index].winningAmount
        ? profileData?.item?.wallet[index].winningAmount
        : 0;
    }
    return 0;
  };

  // const getAccountProfileDetails = async () => {
  //   try {
  //     const res = await getAccountProfile();
  //     if (res?.data) {
  //       setProfileData(res?.data);
  //       localStorage.setItem("profile", JSON.stringify(res?.data));
  //       localStorage.setItem(
  //         "currentD11",
  //         getTotalCoin(res?.data?.item?.wallet)
  //       );
  //     }

  //     func("profile", res?.data?.item);
  //   } catch (error) {
  //     func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
  //   }
  // };

  const handlerJVC = () => {
    func("JVC", "called");
    eventTracking(events.JOIN_VIA_INVITE_CODE);
    setShowJVC(true);
  };

  const handlerJoin = () => {
    func("clikced");
    setShowJoinModal(true);
  };

  const handlerJoinNow = () => {
    func("handlerjoin");
    setShowJoinModal(false);
    setShowTournamentModal(true);
  };

  const handlerWinning = () => {
    func("clicked");
    setShowWinningModal((prev) => true);
  };

  useEffect(() => {
    func("active nav", activeNav);
    let index = null;
    navsv.forEach((element, ind) => {
      if (element == activeNav) index = ind;
    });
    func("index 126", index);
    // getAccountProfileDetails();
  }, []);

  useEffect(() => {
    // alert(showJVC);
  }, [showJVC]);

  const getTotalDiamond = () => {
    // let index =
    //   profileData?.item &&
    //   profileData?.item?.wallet &&
    //   profileData?.item?.wallet.findIndex(
    //     (obj) => obj.currencyData?.code == "gp_diamond"
    //   );
    // // let index = accountResponse.wallet.findIndex(obj => obj.currencyData.name == 'gp_diamond')
    // if (index > -1) {
    //   return profileData?.item?.wallet[index].winningAmount != null
    //     ? profileData?.item?.wallet[index].winningAmount
    //     : 0;
    // }
    // return 0;
    let index = profileData?.item?.wallet?.findIndex(
      (obj) => obj.currencyData?.code == "gp_diamond"
    );

    if (index > -1) {
      return profileData?.item?.wallet[index].winningAmount
        ? profileData?.item?.wallet[index].winningAmount
        : 0;
    }
    return 0;
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={2000} />
      <nav class="navbar navbar-top fixed-top navbar-expand">
        <div class="collapse navbar-collapse justify-content-between">
          <div class="navbar-logo">
            <button
              class={`navbar-toggler mainMenuToggler ${
                isActiveMenu ? "collapsed" : ""
              }`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded={!isActiveMenu ? "false" : "true"}
              aria-label="Toggle navigation"
              onClick={() => seActiveMenu(!isActiveMenu)}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </button>
            <Link class="navbar-brand" to="/home">
              <img src={Logo} alt="" />
            </Link>
          </div>
          <div class="navRight d-flex align-items-center justify-content-sm-between justify-content-end">
            <nav aria-label="breadcrumb" className="d-none d-sm-block">
              <ol class="breadcrumb mb-0">
                <li class="breadcrumb-item">
                  {/* {console.log("navsv", navName[activeNav])} */}
                  <Link to={navsv[activeNav]}>{t(navName[activeNav])}</Link>
                </li>
                {/* <li class="breadcrumb-item"></li> */}
                {window.location.pathname.split("/")[
                  window.location.pathname.split("/").length - 1
                ] === "my-profile" ? (
                  <>
                    <li class="breadcrumb-item" aria-current="page">
                      <Link to="/home/my-profile">
                        {/* {t("header.my_profile")} */}

                        {t(
                          window.location.pathname.split("/")[
                            window.location.pathname.split("/").length - 1
                          ]
                        )}
                      </Link>
                    </li>
                  </>
                ) : window.location.pathname.split("/")[
                    window.location.pathname.split("/").length - 1
                  ] === "legality" ? (
                  <>
                    <li class="breadcrumb-item" aria-current="page">
                      <Link to="/home/legality">
                        {/* {t("header.my_profile")} */}

                        {t(
                          window.location.pathname.split("/")[
                            window.location.pathname.split("/").length - 1
                          ]
                        )}
                      </Link>
                    </li>
                  </>
                ) : window.location.pathname.split("/")[
                    window.location.pathname.split("/").length - 2
                  ] === "user-profile" ? (
                  <>
                    <li class="breadcrumb-item" aria-current="page">
                      <Link>{t("header.user_profile")}</Link>
                    </li>
                  </>
                ) : window.location.pathname.split("/")[
                    window.location.pathname.split("/").length - 1
                  ] === "free-games" ? (
                  <>
                    <li class="breadcrumb-item" aria-current="page">
                      <Link to="/home/free-games">
                        {t("header.free_games")}
                      </Link>
                    </li>
                  </>
                ) : activeNav == 0 &&
                  window.location.pathname.split("/").length > 2 ? (
                  <>
                    <li class="breadcrumb-item" aria-current="page">
                      <Link to="/home/tournaments">
                        {localStorage.getItem("activeGame")}
                      </Link>
                    </li>
                    {window.location.pathname.split("/")[
                      window.location.pathname.split("/").length - 1
                    ] == "tournaments" ? (
                      <li
                        // class="breadcrumb-item"
                        aria-current="page"
                        style={{ textTransform: "capitalize" }}
                      >
                        {/* <Link to={window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]}> */}
                        {/* {
                          window.location.pathname.split("/")[
                            window.location.pathname.split("/").length - 1
                          ]
                        } */}
                        {/* </Link> */}
                      </li>
                    ) : window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 1
                      ] == "private-contest" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="/home/private-contest">
                            {/* {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[0]
                            }{" "}
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[1]
                            } */}
                            {t(
                              window.location.pathname.split("/")[
                                window.location.pathname.split("/").length - 1
                              ]
                            )}
                          </Link>
                        </li>
                      </>
                    ) : // window.location.pathname.split("/")[
                    //   window.location.pathname.split("/").length - 2
                    // ] == "private-contest" ?
                    //  (
                    //   <>
                    //     <li
                    //       class="breadcrumb-item"
                    //       aria-current="page"
                    //       style={{ textTransform: "capitalize" }}
                    //     >
                    //       <Link to="/home/private-contest">
                    //         {
                    //           window.location.pathname
                    //             .split("/")
                    //           [
                    //             window.location.pathname.split("/").length - 2
                    //           ].split("-")[0]
                    //         }{" "}
                    //         {
                    //           window.location.pathname
                    //             .split("/")
                    //           [
                    //             window.location.pathname.split("/").length - 2
                    //           ].split("-")[1]
                    //         }
                    //       </Link>
                    //     </li>
                    //     <li
                    //       class="breadcrumb-item"
                    //       aria-current="page"
                    //       style={{ textTransform: "capitalize" }}
                    //     >
                    //       {
                    //         window.location.pathname
                    //           .split("/")
                    //         [
                    //           window.location.pathname.split("/").length - 1
                    //         ].split("-")[0]
                    //       }{" "}
                    //       {
                    //         window.location.pathname
                    //           .split("/")
                    //         [
                    //           window.location.pathname.split("/").length - 1
                    //         ].split("-")[1]
                    //       }
                    //     </li>
                    //   </>
                    // )
                    // :
                    window.location.pathname.split("/").length > 3 &&
                      window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 2
                      ] == "manage-contest" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="/home/private-contest">
                            {/* {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 3
                                ].split("-")[0]
                            }{" "}
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 3
                                ].split("-")[1]
                            } */}
                            {t(
                              window.location.pathname.split("/")[
                                window.location.pathname.split("/").length - 3
                              ]
                            )}
                          </Link>
                        </li>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          {/* {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 2
                              ].split("-")[0]
                          }{" "}
                          {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 2
                              ].split("-")[1]
                          } */}
                          {t(
                            window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 2
                            ]
                          )}
                        </li>
                      </>
                    ) : window.location.pathname.split("/").length > 3 &&
                      window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 1
                      ] == "create-contest" ? (
                      <>
                        {/* { console.log(  window.location.pathname.split("/"))} */}
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="/home/private-contest">
                            {/* {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 3
                              ].split("-")[0]
                          }{" "}
                          {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 3
                              ].split("-")[1]
                          } */}

                            {t(
                              window.location.pathname.split("/")[
                                window.location.pathname.split("/").length - 2
                              ]
                            )}
                          </Link>
                        </li>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          {/* {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[1]
                        } */}
                          {/* {console.log(t(window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 1
                              ]))} */}
                          {t(
                            window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 1
                            ]
                          )}
                        </li>
                      </>
                    ) : window.location.pathname.split("/").length > 3 &&
                      window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 2
                      ] == "edit-contest" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="/home/private-contest">
                            {/* {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 3
                              ].split("-")[0]
                          }{" "}
                          {
                            window.location.pathname
                              .split("/")
                              [
                                window.location.pathname.split("/").length - 3
                              ].split("-")[1]
                          } */}
                            {t(
                              window.location.pathname.split("/")[
                                window.location.pathname.split("/").length - 3
                              ]
                            )}
                          </Link>
                        </li>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          {/* {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[1]
                        } */}
                          {t(
                            window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 2
                            ]
                          )}
                        </li>
                      </>
                    ) : window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 1
                      ] == "my-contest" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link>
                            {/* {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[0]
                            }{" "} */}
                            {t(
                              window.location.pathname.split("/")[
                                window.location.pathname.split("/").length - 1
                              ]
                            )}
                          </Link>
                        </li>
                      </>
                    ) : window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 1
                      ] == "payment-status" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="">
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[0]
                            }{" "}
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[1]
                            }
                          </Link>
                        </li>
                      </>
                    ) : window.location.pathname.split("/")[
                        window.location.pathname.split("/").length - 1
                      ] == "payment-status-subscription" ? (
                      <>
                        <li
                          class="breadcrumb-item"
                          aria-current="page"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Link to="">
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[0]
                            }{" "}
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[1]
                            }
                            {
                              window.location.pathname
                                .split("/")
                                [
                                  window.location.pathname.split("/").length - 1
                                ].split("-")[2]
                            }
                          </Link>
                        </li>
                      </>
                    ) : (
                      <li class="breadcrumb-item" aria-current="page">
                        {window.location.pathname.split("/")[
                          window.location.pathname.split("/").length - 2
                        ] == "tournament-details"
                          ? t("tournament-details")
                          : window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 2
                            ] == "contest-details"
                          ? t("contest-details")
                          : window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 2
                            ] == "scrim-details"
                          ? t("contest-details")
                          : ""}
                      </li>
                    )}
                  </>
                ) : activeNav == 1 &&
                  window.location.pathname.split("/").length > 3 ? (
                  <>
                    {
                      // window.location.pathname.split('/')[window.location.pathname.split('/').length - 1] == 'tournaments'
                      <li
                        class="breadcrumb-item"
                        aria-current="page"
                        style={{ textTransform: "capitalize" }}
                      >
                        {/* <Link to={window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]}> */}
                        {/* {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[1]
                        } */}
                        {console.log(
                          t(
                            window.location.pathname.split("/")[
                              window.location.pathname.split("/").length - 1
                            ]
                          )
                        )}
                        {t(
                          window.location.pathname.split("/")[
                            window.location.pathname.split("/").length - 1
                          ]
                        )}
                        {/* </Link> */}
                      </li>
                    }
                  </>
                ) : activeNav == 5 &&
                  window.location.pathname.split("/").length > 3 ? (
                  <>
                    {window.location.pathname.split("/")[
                      window.location.pathname.split("/").length - 1
                    ] == "raise-a-complaint" ? (
                      <li
                        class="breadcrumb-item"
                        aria-current="page"
                        style={{ textTransform: "capitalize" }}
                      >
                        {/* <Link to={window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]}> */}
                        {/* {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[1]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[2]
                        } */}
                        {t(
                          window.location.pathname.split("/")[
                            window.location.pathname.split("/").length - 1
                          ]
                        )}
                        {/* </Link> */}
                      </li>
                    ) : (
                      <li
                        class="breadcrumb-item"
                        aria-current="page"
                        style={{ textTransform: "capitalize" }}
                      >
                        {/* <Link to={window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]}> */}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 2
                            ].split("-")[1]
                        }{" "}
                      </li>
                    )}
                  </>
                ) : activeNav == 6 &&
                  window.location.pathname.split("/").length > 3 ? (
                  <>
                    {window.location.pathname.split("/")[
                      window.location.pathname.split("/").length - 1
                    ] == "get-premium" ? (
                      <li
                        class="breadcrumb-item"
                        aria-current="page"
                        style={{ textTransform: "capitalize" }}
                      >
                        {/* <Link to={window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]}> */}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[0]
                        }{" "}
                        {
                          window.location.pathname
                            .split("/")
                            [
                              window.location.pathname.split("/").length - 1
                            ].split("-")[1]
                        }{" "}
                      </li>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
                {/* <li class="breadcrumb-item" aria-current="page">
                  <a href="#">{gameName}</a>
                </li> */}
                {/* <li class="breadcrumb-item active" aria-current="page">
                Tournaments
              </li> */}
              </ol>
            </nav>
            <div class="rightNav">
              <div class="badge">
                <span class="badge-icon" style={{ caretColor: "transparent" }}>
                  {console.log('profileData',profileData)}
                  <img
                    src={
                      URL.imageUrl +
                      profileData?.item?.wallet[
                        profileData?.item?.wallet?.findIndex(
                          (obj) => obj.currencyData?.code == "gp_coin"
                        )
                      ]?.currencyData?.img?.default
                    }
                    alt=""
                    className="icon-30"
                  />
                </span>
                {/* {localStorage.getItem("currentD11")}{" "} */}
                {getTotalCoin()}
              </div>
              <div class="badge">
                <span class="badge-icon" style={{ caretColor: "transparent" }}>
                  <img
                    src={
                      URL.imageUrl +
                      profileData?.item?.wallet[
                        profileData?.item?.wallet?.findIndex(
                          (obj) => obj.currencyData?.code == "gp_diamond"
                        )
                      ]?.currencyData?.img?.default
                    }
                    alt=""
                    className="icon-30"
                  />
                </span>
                {/* {localStorage.getItem("currentD11")}{" "} */}
                {getTotalDiamond()}
              </div>
              {/* <div class="badge">
                <span class="badge-icon">
                  <img src={Diamond} alt="" />
                </span>
                {/* {localStorage.getItem("currentD11")}{" "} */}
              {/* {getTotalDiamond()} */}

              {/* {getTotalDiamond()} */}
              {/* </div> */}
              <div class="dropdown customDropdown ms-xl-5 ms-3">
                <span
                  class="dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedLanguage}
                </span>

                <ul class="dropdown-menu">
                  {languages?.map((ele, ind) => (
                    <li key={ind}>
                      <span
                        class="dropdown-item"
                        onClick={(e) => {
                          setLoader(true);
                          i18next.changeLanguage(ele?.code?.toLowerCase());
                          localStorage.setItem("GJLang", ele.name);
                          localStorage.setItem(
                            "GJLangCode",
                            ele?.code?.toLowerCase()
                          );
                          Cookies.set("GJLang", ele.name);
                          Cookies.set("GJLangCode", ele?.code?.toLowerCase());
                          eventTracking(events.CHANGE_LANGUAGE, {
                            GJ_LanguageName: ele?.code?.toLowerCase(),
                          });
                          // const head = document.head;
                          // const link = document.createElement("link");
                          // link.type = "text/css";
                          // link.rel = "stylesheet";

                          // // Set the href based on the language
                          // link.href =
                          //   currentLang === "ar"
                          //     ? `"%PUBLIC_URL%/assets/css/bootstrap.rtl.min.css`
                          //     : `"%PUBLIC_URL%/assets/css/bootstrap.min.css`;

                          // // Clear existing stylesheets, if any
                          // const existingLinks = head.querySelectorAll(
                          //   'link[data-type="bootstrap"]'
                          // );
                          // existingLinks.forEach((existingLink) =>
                          //   existingLink.remove()
                          // );

                          // // Add the new stylesheet link
                          // link.dataset.type = "bootstrap";
                          // head.appendChild(link);
                          // console.log(`"%PUBLIC_URL%/assets/css/bootstrap.min.css`, `${process.env.REACT_APP_CLIENT_BASE_URL}assets/css/bootstrap.rtl.min.css`)
                          window.location.href = window.location.pathname;
                          setLoader(false);
                        }}
                      >
                        {ele.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <div class="dropdown customDropdown userProfileDropdown ms-xl-5 ms-sm-4 ms-2">
                <span
                  class="dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span class="userIcon">
                    {
                      profileData?.item?.level?.level?.featuredImage?.default ?
                      <img
                      src={
                        URL.imageUrl +
                        profileData?.item?.level?.level?.featuredImage?.default
                      }
                      alt=""
                      />
                      :
                      (
                        <div
                          className="user-initials-circle"
                          style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            backgroundColor: "#007c93",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "20px",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          {profileData?.item?.gamerjiName.charAt(0).toUpperCase()}
                        </div>
                      )
                    }
                    
                  </span>
                  <span className="profileName">
                    <span style={{ caretColor: "transparent" }}>
                      {profileData?.item?.gamerjiName}
                    </span>
                  </span>
                </span>

                <ul class="dropdown-menu">
                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        navigate(routes.myProfile);
                        eventTracking(events.my_profile);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={Profile} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 8C6.2352 8 4.8 6.5648 4.8 4.8C4.8 3.0352 6.2352 1.6 8 1.6C9.7648 1.6 11.2 3.0352 11.2 4.8C11.2 6.5648 9.7648 8 8 8ZM11.0064 8.53838C12.0992 7.65918 12.8 6.312 12.8 4.8C12.8 2.1488 10.6512 0 8 0C5.3488 0 3.2 2.1488 3.2 4.8C3.2 6.312 3.9008 7.65918 4.9936 8.53838C2.0664 9.63838 0 12.356 0 16H1.6C1.6 12 4.4712 9.6 8 9.6C11.5288 9.6 14.4 12 14.4 16H16C16 12.356 13.9336 9.63838 11.0064 8.53838Z"
                            fill={"currentColor"}
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.my_profile")}
                    </span>
                  </li>
                  <li>
                    <span class="dropdown-item cursor" onClick={handlerJVC}>
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={JVC} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2713_65580)">
                            <path
                              d="M4.63412 14.6662C3.75966 14.6625 2.92166 14.3153 2.30079 13.6995C1.99036 13.3953 1.74375 13.0323 1.57539 12.6316C1.40703 12.231 1.32031 11.8007 1.32031 11.3662C1.32031 10.9316 1.40703 10.5013 1.57539 10.1007C1.74375 9.70001 1.99036 9.33697 2.30079 9.03282L4.70079 6.63282C5.00494 6.32239 5.36798 6.07578 5.76864 5.90742C6.1693 5.73906 6.59953 5.65234 7.03412 5.65234C7.46872 5.65234 7.89894 5.73906 8.2996 5.90742C8.70026 6.07578 9.0633 6.32239 9.36746 6.63282C9.46374 6.7612 9.51049 6.92001 9.49911 7.08008C9.48774 7.24015 9.419 7.39075 9.30553 7.50422C9.19205 7.6177 9.04146 7.68643 8.88138 7.69781C8.72131 7.70919 8.5625 7.66244 8.43412 7.56615C8.06026 7.1997 7.55763 6.99444 7.03412 6.99444C6.51062 6.99444 6.00798 7.1997 5.63412 7.56615L3.23412 9.96615C2.86282 10.3375 2.65422 10.8411 2.65422 11.3662C2.65422 11.8913 2.86282 12.3948 3.23412 12.7662C3.60543 13.1375 4.10902 13.3461 4.63412 13.3461C5.15922 13.3461 5.66282 13.1375 6.03412 12.7662L7.53412 11.1995C7.6625 11.1032 7.82131 11.0565 7.98138 11.0678C8.14146 11.0792 8.29205 11.1479 8.40553 11.2614C8.519 11.3749 8.58774 11.5255 8.59911 11.6856C8.61049 11.8456 8.56374 12.0044 8.46746 12.1328L6.96746 13.6995C6.34659 14.3153 5.50859 14.6625 4.63412 14.6662Z"
                              fill={"currentColor"}
                            />
                            <path
                              d="M8.96667 10.3319C8.0922 10.3282 7.2542 9.98104 6.63333 9.36523C6.53705 9.23685 6.4903 9.07805 6.50168 8.91797C6.51305 8.7579 6.58179 8.6073 6.69526 8.49383C6.80874 8.38035 6.95933 8.31162 7.11941 8.30024C7.27948 8.28887 7.43829 8.33561 7.56667 8.4319C7.94053 8.79835 8.44316 9.00361 8.96667 9.00361C9.49017 9.00361 9.99281 8.79835 10.3667 8.4319L12.7667 6.0319C13.138 5.6606 13.3466 5.157 13.3466 4.6319C13.3466 4.1068 13.138 3.6032 12.7667 3.2319C12.3954 2.8606 11.8918 2.652 11.3667 2.652C10.8416 2.652 10.338 2.8606 9.96667 3.2319L8.46667 4.79856C8.33829 4.89485 8.17948 4.9416 8.01941 4.93022C7.85934 4.91885 7.70874 4.85011 7.59526 4.73664C7.48179 4.62316 7.41305 4.47256 7.40168 4.31249C7.3903 4.15242 7.43705 3.99361 7.53333 3.86523L9.03333 2.29857C9.6543 1.69002 10.4903 1.35112 11.3598 1.35551C12.2292 1.3599 13.0618 1.70723 13.6765 2.32202C14.2913 2.9368 14.6387 3.76937 14.6431 4.6388C14.6474 5.50823 14.3085 6.34427 13.7 6.96523L11.3 9.36523C10.6791 9.98104 9.84113 10.3282 8.96667 10.3319Z"
                              fill={"currentColor"}
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2713_65580">
                              <rect
                                width="16"
                                height="16"
                                fill={"currentColor"}
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      {t("right_hand_drop_down.join_via_invite_code")}
                    </span>
                  </li>
                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        setShowDLR(true);
                        eventTracking(events.DAILY_LOGIN_REWARD);
                      }}
                    >
                      <span class="icon">
                        <img class="icon-16 me-2" src={JVC} alt="" />
                      </span>
                      {t("right_hand_drop_down.daily_login_rewards")}
                    </span>
                  </li>
                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        setShowReferFriend(true);
                        eventTracking(events.REFERE);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={Friend} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_2713_65600"
                            style={{"mask-type":"alpha"}}
                            maskUnits="userSpaceOnUse"
                            x="8"
                            y="0"
                            width="8"
                            height="8"
                          >
                            <g clip-path="url(#clip0_2713_65600)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.76 3.88734V1.86562L12.6989 2.90328L12.2349 2.45094C12.9136 1.7719 13.353 1.3267 14.039 0.640625C14.7002 1.30174 15.2048 1.80934 15.8464 2.45094L15.4157 2.90328L14.4 1.86562V3.88734C14.4 5.6547 12.9674 7.08734 11.2 7.08734C9.43264 7.08734 8 5.6547 8 3.88734V0.687344H8.64V3.88734C8.64 5.3011 9.78624 6.44734 11.2 6.44734C12.6138 6.44734 13.76 5.3011 13.76 3.88734Z"
                                fill={"currentColor"}
                              />
                            </g>
                          </mask>
                          <g mask="url(#mask0_2713_65600)">
                            <rect
                              x="10.418"
                              y="1.30859"
                              width="10.9347"
                              height="12.3636"
                              transform="rotate(-12.3058 10.418 1.30859)"
                              fill={"currentColor"}
                            />
                          </g>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.46641 7.46641C6.05457 7.46641 4.90641 6.31825 4.90641 4.90641C4.90641 3.49457 6.05457 2.34641 7.46641 2.34641C8.87825 2.34641 10.0264 3.49457 10.0264 4.90641C10.0264 6.31825 8.87825 7.46641 7.46641 7.46641ZM9.87152 7.89711C10.7458 7.19375 11.3064 6.11601 11.3064 4.90641C11.3064 2.78545 9.58737 1.06641 7.46641 1.06641C5.34545 1.06641 3.62641 2.78545 3.62641 4.90641C3.62641 6.11601 4.18705 7.19375 5.06129 7.89711C2.71953 8.77711 1.06641 10.9512 1.06641 13.8664H2.34641C2.34641 10.6664 4.64337 8.74641 7.46641 8.74641C10.2894 8.74641 12.5864 10.6664 12.5864 13.8664H13.8664C13.8664 10.9512 12.2133 8.77711 9.87152 7.89711Z"
                            fill={"currentColor"}
                          />
                          <defs>
                            <clipPath id="clip0_2713_65600">
                              <rect
                                width="8"
                                height="8"
                                fill={"currentColor"}
                                transform="translate(8)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      {t("right_hand_drop_down.refer_a_friend")}
                    </span>
                  </li>
                  <li>
                    <span
                      className="dropdown-item cursor"
                      onClick={handleApplyPromoCode}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={PromoCode} alt="" /> */}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.40109 9.32813L6.40108 9.32813C5.80069 8.74223 5.80068 7.78815 6.40105 7.20236M6.40109 9.32813L6.40105 7.20236M6.40109 9.32813C6.7009 9.62068 7.09437 9.76652 7.48683 9.76652M6.40109 9.32813L7.48683 9.76652M6.40105 7.20236C6.69136 6.91904 7.07734 6.76328 7.48683 6.76328C7.89633 6.76328 8.28228 6.91909 8.57258 7.20236M6.40105 7.20236L8.57258 7.20236M6.94148 8.80284C7.24483 9.09398 7.73549 9.09246 8.03678 8.79843L8.0368 8.79842C8.18338 8.65542 8.2634 8.46632 8.2634 8.26521C8.2634 8.0641 8.18337 7.875 8.03683 7.73204L8.03683 7.73203C7.89015 7.5889 7.69526 7.5099 7.48687 7.5099C7.27849 7.5099 7.08356 7.5889 6.93688 7.73199L6.94148 8.80284ZM6.94148 8.80284L6.93695 8.79842C6.63536 8.50417 6.63536 8.02626 6.93687 7.732L6.94148 8.80284ZM7.48683 9.76652C7.8793 9.76652 8.27274 9.62068 8.57254 9.32813M7.48683 9.76652L8.57254 9.32813M8.57254 9.32813C8.86297 9.04478 9.02358 8.66703 9.02358 8.26524M8.57254 9.32813L9.02358 8.26524M9.02358 8.26524C9.02358 7.86346 8.86297 7.48568 8.57258 7.20236M9.02358 8.26524L8.57258 7.20236"
                            fill={"currentColor"}
                            stroke={"currentColor"}
                            stroke-width="0.2"
                          />
                          <path
                            d="M6.56121 11.6314L6.56121 11.6314C5.96085 12.2172 5.96085 13.1713 6.56121 13.7572L6.56121 13.7572C6.86106 14.0498 7.2545 14.1956 7.64696 14.1956C8.0395 14.1956 8.4329 14.0497 8.73274 13.7572L8.73274 13.7572C9.3331 13.1713 9.3331 12.2172 8.73274 11.6314L8.73274 11.6314C8.13363 11.0468 7.16024 11.0469 6.56121 11.6314ZM7.09708 12.161L7.09709 12.161C7.3999 11.8655 7.89402 11.8654 8.19691 12.161L8.19691 12.161C8.49843 12.4553 8.49843 12.9332 8.19691 13.2275C7.89405 13.523 7.4 13.5231 7.09708 13.2275C6.79556 12.9332 6.79556 12.4553 7.09708 12.161Z"
                            fill={"currentColor"}
                            stroke={"currentColor"}
                            stroke-width="0.2"
                          />
                          <path
                            d="M9.85314 8.91733L9.85317 8.91732C10.0383 8.82468 10.2669 8.89495 10.3635 9.07861C10.4609 9.26369 10.385 9.48917 10.1984 9.58255C10.1984 9.58255 10.1984 9.58255 10.1984 9.58255L5.28096 12.0447L5.28093 12.0447C5.22575 12.0723 5.16668 12.0855 5.10853 12.0855C4.97202 12.0855 4.83857 12.0127 4.77057 11.8834C4.77057 11.8834 4.77057 11.8834 4.77057 11.8834L4.85908 11.8369C4.78846 11.7026 4.84276 11.5378 4.98043 11.4689L9.85314 8.91733ZM9.85314 8.91733L4.93566 11.3795M9.85314 8.91733L4.93566 11.3795M4.93566 11.3795L4.93565 11.3795L4.98041 11.4689L4.93566 11.3795Z"
                            fill={"currentColor"}
                            stroke={"currentColor"}
                            stroke-width="0.2"
                          />
                          <path
                            d="M10.7641 5.63768C10.5131 5.88255 10.3743 6.20913 10.3743 6.55654C10.3743 6.90395 10.5131 7.23053 10.7641 7.47537C11.0149 7.72015 11.3485 7.85475 11.7022 7.85475C12.056 7.85475 12.3895 7.72015 12.6403 7.47536L12.8162 7.30379H12.7885C12.9454 7.0868 13.0302 6.82801 13.0302 6.55654C13.0302 6.20917 12.8913 5.88255 12.6403 5.63768C12.4821 5.48329 12.2908 5.37292 12.0823 5.31238V4.72472L13.0638 4.81891C13.2879 4.84042 13.4638 5.01437 13.4854 5.22853L13.9122 9.4619C13.9258 9.59754 13.8772 9.73086 13.7776 9.82808L7.13541 16.3094L7.13538 16.3095L10.8339 5.70925M10.7641 5.63768L10.8339 5.70925M10.7641 5.63768C10.7641 5.63768 10.7641 5.63769 10.7641 5.63769L10.8339 5.70925M10.7641 5.63768C10.9223 5.48325 11.1136 5.37288 11.3221 5.31234M10.8339 5.70925C10.9983 5.54883 11.2012 5.43982 11.4221 5.38975M11.3221 5.31234V5.38975H11.4221M11.3221 5.31234V4.65177M11.3221 5.31234C11.3478 5.30487 11.3738 5.29816 11.4 5.29222L11.4221 5.38975M11.4221 5.38975L11.3221 4.65177M11.3221 4.65177L11.4126 4.66045L11.4221 4.5609H11.3221V4.65177ZM11.3221 4.65177L8.72556 4.40255L8.73499 4.30299L8.72544 4.40253L8.72546 4.40254L11.3221 4.65177ZM12.5705 7.40377L12.5705 7.40379L12.5705 7.40377ZM12.5705 7.40377C12.5705 7.40377 12.5705 7.40376 12.5705 7.40375C12.6032 7.37186 12.6338 7.33849 12.6623 7.30379L12.5705 7.40377ZM12.1083 6.94192C12.1375 6.91286 12.1629 6.88118 12.1844 6.84745C11.8262 6.71613 11.5406 6.43751 11.4061 6.08611C11.3678 6.10872 11.3322 6.13583 11.2999 6.16732L12.1083 6.94192ZM12.1083 6.94192L12.1045 6.94563C11.9973 7.05022 11.8549 7.10805 11.7022 7.10805C11.5496 7.10805 11.4071 7.05022 11.2999 6.94562C11.1928 6.8411 11.1345 6.70319 11.1345 6.55647C11.1345 6.40975 11.1928 6.27185 11.2999 6.16733L12.1083 6.94192ZM1.16795 10.4865L1.16794 10.4865C0.810685 10.8351 0.810685 11.4033 1.16794 11.7519L1.16795 11.7519L6.38142 16.8391C6.55396 17.0075 6.78335 17.1 7.02631 17.1C7.26927 17.1 7.49869 17.0075 7.67124 16.8391L14.3134 10.3578L14.3134 10.3578C14.5751 10.1024 14.705 9.74892 14.6687 9.38834L14.3499 6.22597L16.5392 4.08972L16.4694 4.01814L16.5392 4.08971C16.9004 3.73722 17.1 3.26753 17.1 2.76797C17.1 1.73557 16.2401 0.9 15.1882 0.9H13.234C12.182 0.9 11.3221 1.73557 11.3221 2.76797V3.90153L8.79941 3.65938L8.78986 3.75892L8.79941 3.65938C8.43214 3.62413 8.07163 3.74991 7.81013 4.00511L1.16795 10.4865ZM12.4545 7.50379H12.5705H12.5705V7.40383L12.4545 7.50379ZM16.0033 3.56001L16.0732 3.63158L16.0033 3.56001L14.2533 5.26763L14.2419 5.15494C14.1844 4.58368 13.7186 4.13153 13.1378 4.07578L12.0823 3.97448V2.76797C12.0823 2.15205 12.5967 1.64666 13.234 1.64666H15.1882C15.8254 1.64666 16.3398 2.15205 16.3398 2.76797C16.3398 3.06689 16.2207 3.34791 16.0033 3.56001Z"
                            fill={"currentColor"}
                            stroke={"currentColor"}
                            stroke-width="0.2"
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.apply_promo_code")}
                    </span>
                  </li>
                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        setShowGamerjiPointsMOdal(true);
                        eventTracking(events.gamerji_point);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={Points} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 0V16H12.9962V0H3ZM12.5059 15.5098H11.2827C11.7852 15.2105 12.2067 14.789 12.5059 14.2865V15.5098ZM9.74412 15.4998V12.7479H12.496C12.3775 14.211 11.2072 15.3813 9.74412 15.4998ZM12.5059 1.75109H12.2507V2.24134H12.5059V12.2577H9.25391V15.5098H3.49022V2.24134H3.74541V1.75109H3.49022V0.49025H12.5059V1.75109Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M4.74641 1.75H4.24609V2.24025H4.74641V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M5.74641 1.75H5.24609V2.24025H5.74641V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M6.74641 1.75H6.24609V2.24025H6.74641V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M7.74641 1.75H7.24609V2.24025H7.74641V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M8.75031 1.75H8.25V2.24025H8.75031V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M9.75031 1.75H9.25V2.24025H9.75031V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M10.7503 1.75H10.25V2.24025H10.7503V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7503 1.75H11.25V2.24025H11.7503V1.75Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 3.75391H4.24609V4.24416H11.7508V3.75391Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 5.00391H4.24609V5.49416H11.7508V5.00391Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 6.25391H4.24609V6.74416H11.7508V6.25391Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 7.50391H4.24609V7.99416H11.7508V7.50391Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 8.75391H4.24609V9.24416H11.7508V8.75391Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 10.0078H4.24609V10.4981H11.7508V10.0078Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M11.7508 11.2578H4.24609V11.7481H11.7508V11.2578Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M8.99919 12.5078H4.24609V12.9981H8.99919V12.5078Z"
                            fill={"currentColor"}
                          />
                          <path
                            d="M8.99919 13.7578H4.24609V14.2481H8.99919V13.7578Z"
                            fill={"currentColor"}
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.gamerji_points")}
                    </span>
                  </li>

                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        navigate("/home/legality");
                        eventTracking(events.legality);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={Legality} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.96869 3.2915L5.85519 7.479H6.40419L4.39219 3.021H7.49869V13.4065C6.85869 13.43 3.59219 14.49 3.59219 14.49V15H12.3722V14.4555C12.3722 14.4555 9.03319 13.406 8.53019 13.406V3.021H11.5377L9.52519 7.479H10.0742L11.9607 3.2915L13.8472 7.479H14.3962L12.3722 2.996V2.479H8.99519C8.99519 1.8025 8.54169 1.25 8.01269 1.25C7.45319 1.25 7.03019 1.834 7.03019 2.479H3.59119V2.9225L1.53319 7.479H2.08219L3.96869 3.2915ZM9.49069 7.9895C9.49069 9.336 10.4247 10.6305 11.9602 10.6305C13.4612 10.6305 14.4297 9.336 14.4297 7.9895C14.4302 7.9915 9.49069 7.9915 9.49069 7.9895ZM6.36969 7.9895C6.36969 7.992 1.43019 7.992 1.43019 7.9895C1.43019 9.336 2.36419 10.6305 3.89969 10.6305C5.40119 10.6305 6.36969 9.336 6.36969 7.9895Z"
                            fill={"currentColor"}
                            stroke={"currentColor"}
                            stroke-width="0.2"
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.legality")}
                    </span>
                  </li>

                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        setShowFavoriteGame(true);
                        eventTracking(events.FAV_GAMES);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={Favorite} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.0482 3.62797C13.6593 4.24146 14.0024 5.07208 14.0024 5.93797C14.0024 6.80386 13.6593 7.63448 13.0482 8.24797L8.00154 13.3346L2.95487 8.24797C2.50103 7.79107 2.19205 7.21044 2.06661 6.57879C1.94116 5.94713 2.00483 5.2925 2.24964 4.69685C2.49444 4.1012 2.90951 3.591 3.44289 3.23011C3.97626 2.86922 4.60424 2.67368 5.2482 2.66797C6.1093 2.67319 6.9335 3.01821 7.54154 3.62797C7.71888 3.80345 7.87342 4.00056 8.00154 4.21464C8.12965 4.00056 8.2842 3.80345 8.46154 3.62797C8.76112 3.32401 9.11815 3.08263 9.51185 2.91788C9.90556 2.75313 10.3281 2.66828 10.7549 2.66828C11.1817 2.66828 11.6042 2.75313 11.9979 2.91788C12.3916 3.08263 12.7486 3.32401 13.0482 3.62797Z"
                            stroke={"currentColor"}
                            stroke-width="1.33333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.favorite_game")}
                    </span>
                  </li>
                  <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                        setLogoutModal(true);

                        eventTracking(events.LOGOUT);
                      }}
                    >
                      <span class="icon pe-2">
                        {/* <img class="icon-16 me-2" src={LogoutIcon} alt="" /> */}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0013 8H8.66797"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 10L13.942 8.058C13.974 8.026 13.974 7.974 13.942 7.942L12 6"
                            stroke={"currentColor"}
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.6667 3.33333V3C10.6667 2.44771 10.2189 2 9.66667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.4031 2.59695 14 3.33333 14H9.66667C10.2189 14 10.6667 13.5523 10.6667 13V12.6667"
                            stroke={"currentColor"}
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      {t("right_hand_drop_down.logout")}
                    </span>
                  </li>
                  {/* <li>
                    <span
                      class="dropdown-item cursor"
                      onClick={() => {
                       
                        changeTheme(localStorage.getItem('theme') == '1' ? '0' : '1')

                      
                      }}
                    >
                      <span class="icon pe-2">
                     
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0013 8H8.66797"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 10L13.942 8.058C13.974 8.026 13.974 7.974 13.942 7.942L12 6"
                            stroke={"currentColor"}
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.6667 3.33333V3C10.6667 2.44771 10.2189 2 9.66667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.4031 2.59695 14 3.33333 14H9.66667C10.2189 14 10.6667 13.5523 10.6667 13V12.6667"
                            stroke={"currentColor"}
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      {themeName}
                    </span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
      {showJVC && (
        <JoinViaInviteCodeModal showJVC={showJVC} setShowJVC={setShowJVC} />
      )}
      {showAPC && (
        <ApplyPromoCodeModel
          showAPC={showAPC}
          setShowAPC={setShowAPC}
          setShowSPC={setShowSPC}
        />
      )}
      {showSPC && (
        <SuccessPromoCodeModal showSPC={showSPC} setShowSPC={setShowSPC} />
      )}
      {showJoinModal && (
        <JoinModal
          showJoinModal={showJoinModal}
          setShowJoinModal={setShowJoinModal}
          handlerWinning={handlerWinning}
          handlerJoinNow={handlerJoinNow}
        />
      )}
      {showWinningModal && (
        <WinningBreakUp
          showWinningModal={showWinningModal}
          setShowWinningModal={setShowWinningModal}
        />
      )}
      {showTournamentModal && (
        <TournamentModal
          showTournamentModal={showTournamentModal}
          setShowTournamentModal={setShowTournamentModal}
          setShowTournamentConfirmationModal={
            setShowTournamentConfirmationModal
          }
        />
      )}

      {showTournamentConfirmationModal && (
        <TournamentConfirmationModal
          showTournamentConfirmationModal={showTournamentConfirmationModal}
          setShowTournamentConfirmationModal={
            setShowTournamentConfirmationModal
          }
        />
      )}
      {showReferFriend && (
        <ReferAFriend
          showReferFriend={showReferFriend}
          setShowReferFriend={setShowReferFriend}
        />
      )}
      {logoutModal && (
        <Logout
          logoutModal={logoutModal}
          setLogoutModal={setLogoutModal}
          logout={logout}
        />
      )}
      {showGamerjiPointsModal && (
        <GamerjiPoints
          showGamerjiPointsModal={showGamerjiPointsModal}
          setShowGamerjiPointsMOdal={setShowGamerjiPointsMOdal}
        />
      )}
      {showFavoriteGame && (
        <FavoriteGamesModal
          showFavoriteGame={showFavoriteGame}
          setShowFavoriteGame={setShowFavoriteGame}
        />
      )}
      {/* {
        showMyProfile && <MyProfile showMyProfile={showMyProfile} setShowMyProfile={setShowMyProfile} />
      } */}
      {showDLR && (
        <DailyLoginRewardModal showDLR={showDLR} setShowDLR={setShowDLR} />
      )}
    </>
  );
};

export default Navbar;
